(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

/**
 * @file
 * Provides GridStack loaders for view page.
 */

(function ($, Drupal, settings) {
  'use strict';

  function _getGridHeight(items) {
    return _.reduce(items, function (memo, n) {
      var dataGsY = parseInt($(n).attr('data-gs-y'));
      var dataGsHeight = parseInt($(n).attr('data-gs-height'));
      return Math.max(memo, dataGsY + dataGsHeight);
    }, 0);
  }

  /**
   * Implements grid and backbone collections on node edit page.
   */
  $(document).ready(function () {
    var jsonData = $('.field--name-field-paragraphs-gridstack-json');

    if (jsonData.length) {
      jsonData.each(function () {
        var $data = $(this).text();
        var viewGridContent = $(this).parent().find('.grid-stack');
        gridSettings($data, viewGridContent);
      });
    }
  });

  /**
   * Set the settings to the paragraph.
   *
   * @param data
   *   Information about paragraph in json.
   * @param viewGridContent
   *   DOM presentation of paragraph.
   */
  function gridSettings(data, viewGridContent) {
    data = JSON.parse(data);
    var settingsValues = Object.keys(data.settings).map(function (key) {
      return data.settings[key];
    });

    var height = settingsValues[0].cellHeight ? settingsValues[0].cellHeight : 50;
    var verticalMargin = settingsValues[0].verticalMargin ? settingsValues[0].verticalMargin : 0;
    var items = [];
    var nodes = viewGridContent.find('.grid-stack-item');

    nodes.each(function () {
      var $this = $(this);
      var y = $this.attr('data-gs-y');
      var h = $this.attr('data-gs-height');
      var elementsHeight = h * height + verticalMargin * (h - 1);
      var top = y * height + verticalMargin * y + 2;

      if ($this.css('display') != 'none') {
        $this.css('height', elementsHeight);
        $this.css('top', top);
        items.push($this);
      }
    });

    var viewContentHeight = _getGridHeight(items) * (height + verticalMargin) - verticalMargin;
    viewGridContent.css('height', viewContentHeight);
  }
})(jQuery, Drupal, drupalSettings);

},{}]},{},[1]);
